import React, { useRef, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { opentheme } from '../modules/formstore';
import Fab from '@mui/material/Fab';
import RestoreIcon from "@icons/material/PaletteIcon";
import { DeleteKeystorage, Savestorage, DeepCopy} from '../modules/appLibrary';
import { themestyle } from '../modules/formstore';
import Snackbar from '@mui/material/Snackbar';

export default function Theme(props) {

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const stylecollection = useSelector(state => state.env.stylecollection);
    const themeopen = useSelector(state => state.form.opentheme);
    const frmstyle = useSelector(state => state.form.themestyle);
    const dispatch = useDispatch();
    const [value, setValue] = React.useState('BASIC');
    const [open, setOpen] = React.useState(true);
    const [showtheme, setshowtheme] = React.useState('BASIC_0_0');
    const [maincolor, setmaincolor] = React.useState('#93A5A1');
    const theme = useRef({ theme: 0, body: 0, header: 0 });
    const curstyle = useRef(null);
    const vertical = 'top';
    const horizontal = 'center';

    useEffect(() => {
        if (themeopen) {
            //現行Style保持
            curstyle.current = frmstyle;
            var style = stylecollection[theme.current.theme];
            setValue(style.theme);
            dispatch(themestyle({ maincolor: style.maincolor, body: style.body[0], header: style.header[0] }));
       }
    }, [themeopen]);


    function onApply() {
        let msg = "すべての画面に適用しますか？すべての画面に適用する場合Yes、起動中の画面のみ適用する場合はNoをClickして下さい。";
        props.fnc.current.confmsg2(msg, () => Apply(0), () => Apply(1));
    }
    function Apply(mode) {
        if (mode === 0) {   //All
            DeleteKeystorage(corpkey, account, "theme_");
            Savestorage(corpkey, account, "theme_ALL", frmstyle);
        } else {
            Savestorage(corpkey, account, "theme_" + props.formid, frmstyle);
        }
        dispatch(opentheme(false));
    }
    function onClose() {
        //cancel
        dispatch(themestyle(curstyle.current));
        dispatch(opentheme(false));
    }

    function onWheel(e) {
        var style = stylecollection[theme.current.theme];
        var newtheme = DeepCopy(theme.current);
        if (e.deltaY > 0) {
            if (style.header.length > newtheme.header + 1) {
                newtheme.header += 1;
            } else {
                if (style.body.length > newtheme.body + 1) {
                    newtheme.header = 0;
                    newtheme.body += 1;
                } else {
                    if (stylecollection.length > newtheme.theme + 1) {
                        newtheme.theme += 1;
                        newtheme.header = 0;
                        newtheme.body = 0;
                        style = stylecollection[newtheme.theme];
                    }
                }
            }
        } else {
            if (newtheme.header !== 0) {
                newtheme.header -= 1;
            } else {
                if (newtheme.body !== 0) {
                    newtheme.body -= 1;
                    newtheme.header = style.header.length - 1;
                } else {
                    if (newtheme.theme !== 0) {
                        newtheme.theme -= 1;
                        style = stylecollection[newtheme.theme];
                        newtheme.body = style.body.length - 1;
                        newtheme.header = style.header.length - 1;
                    }
                }
            }
        }
        theme.current = newtheme;
        setValue(style.theme);
        dispatch(themestyle({ maincolor: style.maincolor, body: style.body[newtheme.body], header: style.header[newtheme.header] }));
        let t = style.theme.replace('PINK', 'LILAK').replace('BLUE', 'SKY') + "_" + String(newtheme.body) + "_" + String(newtheme.header);
        setshowtheme(t);
        setmaincolor(style.maincolor);
    }

    return (
        <React.Fragment>
            <div style={{
                position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh',
                cursor: 'all-scroll',
                zIndex: 999, opacity: 0 }}
                onWheel={event => onWheel(event)}
            />
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                onClose={()=>setOpen(false)}
                message="マウスホイルでスタイルの切り替えを行います"
            />
            <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 9999 }}>
                <Fab variant="extended" style={{ marginRight: 5 }} onClick={onApply }>
                    適用
                </Fab>
                <Fab variant="extended" onClick={ onClose}>
                    中止
                </Fab>
            </div>
            <div style={{ position: 'absolute', bottom: 0, left: 0, zIndex: 9999, width:'100vw' }}>
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                        var style = stylecollection.find(e => e.theme === newValue);
                        dispatch(themestyle({ maincolor: style.maincolor, body: style.body[0], header: style.header[0] }));
                        var idx = stylecollection.findIndex(e => e.theme === newValue);
                        theme.current = { theme: idx, body: 0, header: 0};
                        let t = style.theme.replace('PINK', 'LILAK').replace('BLUE', 'SKY') + "_0_0";
                        setshowtheme(t);
                        setmaincolor(style.maincolor);
                    }}
                >
                    <BottomNavigationAction label="BASIC" value="BASIC" icon={<RestoreIcon style={{ color:'#93A5A1'}} />} />
                    <BottomNavigationAction label="LILAK" value="PINK" icon={<RestoreIcon style={{ color: '#D5A7B4' }} />} />
                    <BottomNavigationAction label="SKY" value="BLUE" icon={<RestoreIcon style={{ color: '#5482B6' }} />} />
                    <BottomNavigationAction label="LIME" value="LIME" icon={<RestoreIcon style={{ color: '#9E9E40' }} />} />
                    <BottomNavigationAction label="TAN" value="TAN" icon={<RestoreIcon style={{ color: '#F89558' }} />} />
                    <BottomNavigationAction label="SCARLET" value="SCARLET" icon={<RestoreIcon style={{ color: '#C54126' }} />} />
                    <BottomNavigationAction label="SAFFRON" value="SAFFRON" icon={<RestoreIcon style={{ color: '#F4BF3C' }} />} />
               </BottomNavigation>
            </div>
            <div style={{ position: 'absolute', bottom: 5, left: 10, zIndex: 10000, width: '100px', color:maincolor }}>
                {showtheme}
            </div>
        </React.Fragment>
    );
}